// LIVIKING theme.js – performance-sicher
(function () {
  // ---- Sticky-CTA (mobile) ----
  var sticky = document.querySelector('.sticky-cta');
  var pdp = document.querySelector('.pdp');
  if (sticky && pdp) {
    var onScroll = function () {
      var visible = window.scrollY > 300 && window.scrollY < pdp.offsetHeight - 400;
      sticky.style.display = visible ? 'flex' : 'none';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---- Farb-Swatches: Variante aktivieren + Hauptbild/Preis wechseln ----
  var swatches = document.querySelectorAll('[data-swatch]');
  var shippingMap = {};
  var shippingMapEl = document.querySelector('[data-variant-shipping-map]');
  if (shippingMapEl) {
    try { shippingMap = JSON.parse(shippingMapEl.textContent || '{}'); } catch (e) { shippingMap = {}; }
  }
  swatches.forEach(function (sw) {
    sw.addEventListener('click', function () {
      var input = document.querySelector('input[data-option="' + sw.dataset.option + '"][value="' + sw.dataset.value + '"]');
      if (input) { input.checked = true; input.dispatchEvent(new Event('change')); }
      swatches.forEach(function (s) { s.classList.toggle('active', s === sw); });
      // Variante im Formular setzen (verstecktes id-Feld)
      var fid = sw.getAttribute('data-vid');
      if (fid) {
        var hid = document.querySelector('[data-variant-id]');
        if (hid) hid.value = fid;
      }
      // Hauptbild der Galerie auf Variantenbild wechseln
      var vimg = sw.getAttribute('data-img');
      var vfull = sw.getAttribute('data-full-img');
      if (vimg) {
        var slide = document.querySelector('.pdp__stage [data-slide]');
        if (slide) { slide.src = vimg; if (vfull) slide.setAttribute('data-full', vfull); }
      }
      // Preis aktualisieren
      var vprice = sw.getAttribute('data-price');
      var vcmp = sw.getAttribute('data-compare');
      if (vprice) {
        var priceNow = document.querySelector('.pdp__price-now');
        var priceWas = document.querySelector('.pdp__price .price__was');
        if (priceNow) priceNow.textContent = money(parseInt(vprice, 10));
        if (priceWas) {
          if (vcmp && parseInt(vcmp, 10) > parseInt(vprice, 10)) {
            priceWas.textContent = 'UVP ' + money(parseInt(vcmp, 10));
            priceWas.style.display = '';
          } else { priceWas.style.display = 'none'; }
        }
      }
      // Variantenabhängigen Lieferhinweis aktualisieren
      var shipEl = document.querySelector('.ship-badge');
      if (shipEl) {
        var variantShipping = shippingMap[fid] || sw.getAttribute('data-shipping') || shipEl.getAttribute('data-default-shipping') || '';
        shipEl.textContent = variantShipping;
      }
    });
  });

  var initialVariantEl = document.querySelector('[data-variant-id]');
  var initialShipEl = document.querySelector('.ship-badge');
  if (initialVariantEl && initialShipEl && shippingMap[initialVariantEl.value]) {
    initialShipEl.textContent = shippingMap[initialVariantEl.value];
  }

  // ---- Galerie-Thumbnails ----
  var thumbs = document.querySelectorAll('[data-thumb]');
  thumbs.forEach(function (th) {
    th.addEventListener('click', function () {
      var slides = document.querySelectorAll('[data-slide]');
      slides.forEach(function (s, i) { s.style.display = (i === parseInt(th.dataset.target, 10)) ? '' : 'none'; });
    });
  });

  // ---- Galerie: Desktop-Hover-Zoom (transform-origin folgt Maus) ----
  var stageEl = document.querySelector('[data-stage]');
  if (stageEl) {
    var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (finePointer) {
      stageEl.addEventListener('mousemove', function (e) {
        var r = stageEl.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        stageEl.style.setProperty('--zx', x.toFixed(1) + '%');
        stageEl.style.setProperty('--zy', y.toFixed(1) + '%');
      });
    }
  }

  // ---- Lightbox (Klick auf Hauptbild) ----
  var lbOverlay = null;
  function lbSlideSrc(slide) {
    return slide.getAttribute('data-full') || slide.src;
  }
  function lbOpen(slide) {
    var slides = Array.prototype.slice.call(document.querySelectorAll('.pdp__stage [data-slide]'));
    if (!slides.length) return;
    var idx = slides.indexOf(slide); if (idx < 0) idx = 0;
    if (lbOverlay) { lbClose(); }
    lbOverlay = document.createElement('div');
    lbOverlay.className = 'lb';
    lbOverlay.setAttribute('role', 'dialog');
    lbOverlay.setAttribute('aria-modal', 'true');
    var img = document.createElement('img');
    img.className = 'lb__img'; img.alt = slide.alt || '';
    var btnPrev = document.createElement('button');
    btnPrev.className = 'lb__nav lb__nav--prev'; btnPrev.type = 'button'; btnPrev.setAttribute('aria-label', 'Vorheriges Bild'); btnPrev.innerHTML = '&#8249;';
    var btnNext = document.createElement('button');
    btnNext.className = 'lb__nav lb__nav--next'; btnNext.type = 'button'; btnNext.setAttribute('aria-label', 'Nächstes Bild'); btnNext.innerHTML = '&#8250;';
    var btnClose = document.createElement('button');
    btnClose.className = 'lb__close'; btnClose.type = 'button'; btnClose.setAttribute('aria-label', 'Schließen'); btnClose.innerHTML = '&#10005;';
    var zoomScale = 1;
    var zoomX = 0;
    var zoomY = 0;
    var pinchStartDistance = 0;
    var pinchStartScale = 1;
    var touchStartX = 0;
    var touchStartY = 0;
    var lastTouchX = 0;
    var lastTouchY = 0;
    function applyZoom() {
      img.style.transform = 'translate3d(' + zoomX + 'px,' + zoomY + 'px,0) scale(' + zoomScale + ')';
      img.style.cursor = zoomScale > 1 ? 'grab' : 'zoom-in';
    }
    function resetZoom() {
      zoomScale = 1; zoomX = 0; zoomY = 0;
      pinchStartDistance = 0; pinchStartScale = 1;
      applyZoom();
    }
    function touchDistance(touches) {
      var dx = touches[0].clientX - touches[1].clientX;
      var dy = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }
    function clampPan() {
      var maxX = Math.max(0, (img.offsetWidth * zoomScale - window.innerWidth) / 2);
      var maxY = Math.max(0, (img.offsetHeight * zoomScale - window.innerHeight) / 2);
      zoomX = Math.max(-maxX, Math.min(maxX, zoomX));
      zoomY = Math.max(-maxY, Math.min(maxY, zoomY));
    }
    function show(i) {
      i = (i + slides.length) % slides.length; idx = i;
      resetZoom();
      img.src = lbSlideSrc(slides[i]);
      img.alt = slides[i].alt || '';
      btnPrev.style.visibility = slides.length > 1 ? 'visible' : 'hidden';
      btnNext.style.visibility = slides.length > 1 ? 'visible' : 'hidden';
    }
    btnPrev.addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
    btnNext.addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
    btnClose.addEventListener('click', lbClose);
    lbOverlay.addEventListener('click', function (e) { if (e.target === lbOverlay) lbClose(); });
    lbOverlay.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        pinchStartDistance = touchDistance(e.touches);
        pinchStartScale = zoomScale;
      } else if (e.touches.length === 1) {
        touchStartX = lastTouchX = e.touches[0].clientX;
        touchStartY = lastTouchY = e.touches[0].clientY;
      }
    }, { passive: true });
    lbOverlay.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && pinchStartDistance) {
        e.preventDefault();
        zoomScale = Math.max(1, Math.min(3, pinchStartScale * (touchDistance(e.touches) / pinchStartDistance)));
        clampPan(); applyZoom();
      } else if (e.touches.length === 1 && zoomScale > 1) {
        e.preventDefault();
        var dx = e.touches[0].clientX - lastTouchX;
        var dy = e.touches[0].clientY - lastTouchY;
        zoomX += dx; zoomY += dy;
        lastTouchX = e.touches[0].clientX; lastTouchY = e.touches[0].clientY;
        clampPan(); applyZoom();
      }
    }, { passive: false });
    lbOverlay.addEventListener('touchend', function (e) {
      if (e.touches.length === 0) pinchStartDistance = 0;
      if (zoomScale > 1 || !touchStartX || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      touchStartX = 0; touchStartY = 0;
      if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy) || slides.length < 2) return;
      show(dx < 0 ? idx + 1 : idx - 1);
    }, { passive: true });
    lbOverlay.addEventListener('touchcancel', function () {
      touchStartX = 0; touchStartY = 0; pinchStartDistance = 0;
    }, { passive: true });
    lbOverlay.appendChild(btnPrev); lbOverlay.appendChild(btnNext); lbOverlay.appendChild(btnClose); lbOverlay.appendChild(img);
    document.body.appendChild(lbOverlay);
    document.body.classList.add('lb-open');
    show(idx);
    document.addEventListener('keydown', lbKey);
  }
  function lbClose() {
    if (lbOverlay) { lbOverlay.remove(); lbOverlay = null; }
    document.body.classList.remove('lb-open');
    document.removeEventListener('keydown', lbKey);
  }
  function lbKey(e) {
    if (!lbOverlay) return;
    if (e.key === 'Escape') { lbClose(); return; }
    var slides = document.querySelectorAll('.pdp__stage [data-slide]');
    var idx = Array.prototype.indexOf.call(slides, lbOverlay.querySelector('.lb__img') ? Array.prototype.find.call(slides, function (s) { return lbSlideSrc(s) === lbOverlay.querySelector('.lb__img').src; }) : null);
    if (e.key === 'ArrowLeft') { var p = document.querySelector('.lb__nav--prev'); if (p) p.click(); }
    if (e.key === 'ArrowRight') { var n = document.querySelector('.lb__nav--next'); if (n) n.click(); }
  }
  if (stageEl) {
    stageEl.addEventListener('click', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-slide')) { lbOpen(e.target); }
    });
  }

  // ---- Mobile-Navigation ----
  var burger = document.querySelector('[data-burger]');
  var mobNav = document.querySelector('[data-mobile-nav]');
  if (burger && mobNav) {
    burger.addEventListener('click', function () {
      var open = mobNav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    mobNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { mobNav.classList.remove('is-open'); burger.setAttribute('aria-expanded', 'false'); });
    });
  }

  // ---- Warenkorb-Drawer ----
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var bodyEl = document.querySelector('[data-cart-body]');
  var totalEl = document.querySelector('[data-cart-total]');
  var discountStatusEl = document.querySelector('[data-cart-discount-status]');
  var checkoutBtn = document.querySelector('[data-cart-checkout]');
  var cardsOpen = document.querySelectorAll('[data-cart-open]');

  function money(cents) {
    if (cents === null || cents === undefined) return '';
    try { return '€' + (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    catch (e) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
  }

  function updateBadge(count) {
    cardsOpen.forEach(function (b) {
      var badge = b.querySelector('.cart-count');
      if (badge) {
        if (count > 0) { badge.textContent = count; badge.style.display = 'inline-block'; } else { badge.style.display = 'none'; }
      } else {
        var base = 'Warenkorb';
        if (count > 0) { b.textContent = base + ' (' + count + ')'; } else { b.textContent = base; }
      }
    });
  }

  function renderDiscountStatus(cart) {
    if (!discountStatusEl) return;
    var discount = Number(cart && cart.total_discount || 0);
    if (!discount && cart && Number(cart.original_total_price) > Number(cart.total_price)) {
      discount = Number(cart.original_total_price) - Number(cart.total_price);
    }
    if (!cart || !cart.item_count) {
      discountStatusEl.hidden = true;
      return;
    }
    discountStatusEl.hidden = false;
    if (discount > 0) {
      discountStatusEl.textContent = 'Rabatt angewendet: −' + money(discount);
      discountStatusEl.classList.add('is-applied');
    } else {
      discountStatusEl.textContent = 'Rabattcode im Checkout einlösen';
      discountStatusEl.classList.remove('is-applied');
    }
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('drawer-locked');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('drawer-locked');
  }

  function renderCart(cart) {
    if (cart && cart.item_count === 0) {
      bodyEl.innerHTML = '<p class="cart-drawer__empty">' + 'Dein Warenkorb ist leer' + '</p>';
      if (totalEl) totalEl.textContent = money(cart.total_price);
      renderDiscountStatus(cart);
      updateBadge(0);
      return;
    }
    if (!cart || !cart.items) return;
    bodyEl.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image + '" width="72" height="72" alt="">' : '<span class="cd-noimg"></span>';
      return '<div class="cd-item">' +
        img +
        '<div class="cd-meta"><div class="cd-title">' + (it.title || '') + '</div>' +
        '<div class="cd-qty">' +
        '<button type="button" data-qty data-key="' + it.key + '" data-delta="-1" aria-label="Weniger">−</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-qty data-key="' + it.key + '" data-delta="1" aria-label="Mehr">+</button>' +
        '</div></div>' +
        '<div class="cd-sub"><span>' + money(it.line_price) + '</span>' +
        '<button type="button" class="cd-remove" data-remove data-key="' + it.key + '" aria-label="Entfernen">✕</button></div>' +
        '</div>';
    }).join('');
    if (totalEl) totalEl.textContent = money(cart.total_price);
    renderDiscountStatus(cart);
    updateBadge(cart.item_count || 0);
  }

  function fetchCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  if (drawer) {
    cardsOpen.forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); fetchCart(); openDrawer(); });
    });
    var closeBtn = drawer.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    bodyEl.addEventListener('click', function (e) {
      var q = e.target.closest('[data-qty]');
      if (q) {
        var key = q.dataset.key;
        var cur = parseInt(q.closest('.cd-qty').querySelector('span').textContent, 10);
        var next = Math.max(0, cur + parseInt(q.dataset.delta, 10));
        if (next === 0) return;
        fetch('/cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: next })
        }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
      }
      var rm = e.target.closest('[data-remove]');
      if (rm) {
        fetch('/cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: rm.dataset.key, quantity: 0 })
        }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
      }
    });
  }

  // Add-To-Cart-Intercept
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        body: new FormData(form)
      }).then(function (r) {
        if (btn) { btn.disabled = false; }
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        fetchCart();
        openDrawer();
      }).catch(function () {
        if (btn) { btn.disabled = false; }
      });
    });
  });

  // ---- Quick-Add auf Produktkarten ----
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var id = btn.dataset.variant;
      if (!id || btn.disabled) return;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      }).then(function (r) {
        btn.disabled = false;
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        fetchCart();
        openDrawer();
      }).catch(function () { btn.disabled = false; });
    });
  });

  // ---- PDP-Cross-Sell: Variantenpreis + variantensicher direkt in den Warenkorb ----
  document.querySelectorAll('.card--cross-sell').forEach(function (card) {
    var select = card.querySelector('[data-cross-sell-variant]');
    var priceEl = card.querySelector('[data-cross-sell-price]');
    var compareEl = card.querySelector('[data-cross-sell-compare]');
    var imageEl = card.querySelector('[data-cross-sell-image]');
    var btn = card.querySelector('[data-cross-sell-add]');
    if (select && priceEl) {
      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        var price = parseInt(option.dataset.price || '0', 10);
        var compare = parseInt(option.dataset.compare || '0', 10);
        if (imageEl && option.dataset.image) imageEl.src = option.dataset.image;
        priceEl.textContent = money(price);
        priceEl.dataset.price = price;
        if (compareEl) {
          if (compare > price) { compareEl.hidden = false; compareEl.textContent = money(compare); }
          else { compareEl.hidden = true; compareEl.textContent = ''; }
        }
      });
    }
    if (btn) btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var id = select ? select.value : btn.dataset.variant;
      if (!id) return;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('cross-sell add failed');
        return r.json();
      }).then(function () {
        fetchCart();
        openDrawer();
      }).catch(function () {}).finally(function () { btn.disabled = false; });
    });
  });

  // ---- Sanfte Sektions-Animation (Premium-Feeling) ----
  if ('IntersectionObserver' in window) {
    var secs = document.querySelectorAll('main section');
    if (secs.length) {
      secs.forEach(function (s) { s.classList.add('reveal'); });
      var ro = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); ro.unobserve(en.target); }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
      secs.forEach(function (s) { ro.observe(s); });
    }
  } else {
    document.querySelectorAll('main section').forEach(function (s) { s.classList.add('is-in'); });
  }
})();
  // ---- FAQ: "Weitere Fragen anzeigen" ----
  document.querySelectorAll('[data-faq]').forEach(function(faq){
    var toggle = faq.querySelector('[data-faq-toggle]');
    var more = faq.querySelector('[data-faq-more]');
    if (!toggle || !more) return;
    toggle.addEventListener('click', function(){
      var hidden = more.hidden;
      more.hidden = !hidden;
      toggle.hidden = !hidden;
      if (hidden) {
        // Neuen Inhalt sanft ins Bild holen
        more.animate([{opacity:0},{opacity:1}], {duration:260});
      }
    });
  });

  // ---- Titel Auto-Fit (Mobile): skaliert so, dass der Titel eine Zeile nutzt ----
  (function () {
    var titles = document.querySelectorAll('[data-autofit-title]');
    if (!titles.length) return;
    var isMobile = window.matchMedia && window.matchMedia('(max-width:820px)');
    var MIN_PX = 17, MAX_PX = 40, SAFE = 0.95; // 5% Sicherheitsabstand -> keine Ellipsis
    var resizeTimer = null;
    function fit() {
      if (!isMobile.matches) { titles.forEach(function (t) { t.style.fontSize = ''; }); return; }
      titles.forEach(function (t) {
        var avail = t.clientWidth;               // verfügbare Containerbreite
        t.style.fontSize = '100px';             // Referenzprobe
        var probe = t.scrollWidth;              // Textbreite bei 100px-Schrift
        if (!probe) { t.style.fontSize = ''; return; }
        var fits = (100 / probe) * avail * SAFE; // 95% der Breite nutzen (Puffer gegen Ellipsis)
        // Mobile: kurze Titel wachsen bis 40px (wie Desktop-max), lange schrumpfen bis 17px
        t.style.fontSize = Math.min(MAX_PX, Math.max(MIN_PX, fits)) + 'px';
        // Notbremse: passt selbst bei 17px nicht -> CSS-Ellipsis greift
      });
    }
    function onResize() { clearTimeout(resizeTimer); resizeTimer = setTimeout(fit, 120); }
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', onResize, { passive: true });
    function fitSoon() {
      if (window.requestAnimationFrame) { window.requestAnimationFrame(fit); }
      else { fit(); }
      setTimeout(fit, 180); // Nachmessung nach Layout-Stabilisierung (Header/Bilder)
    }
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(fitSoon); } else { fitSoon(); }
    window.addEventListener('load', fitSoon, { passive: true });
  })();
